import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, shallowRef } from 'vue'

import {
  MicrofrontendEvents,
  showCreateShipmentFlow,
  publish,
} from '@sennder/senn-node-microfrontend-event-bus'
import { createMfWrapper, ComponentDefinition } from '@sennder/shell-utilities'

import { logger } from '@/services/logger/loggers'
import router from '@/router'
import {
  getRenderer,
  MFRepositories,
  Repositories,
} from '@sennder/microfrontend-registry'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateShipment',
  setup(__props) {

const loaded = ref(false)
const mfWrapper = shallowRef<ComponentDefinition>()

const onAddShipmentClick = () => {
  publish<showCreateShipmentFlow>({
    name: MicrofrontendEvents.showCreateShipmentFlow,
    data: {},
  })
}

onMounted(async () => {
  mfWrapper.value = await createMfWrapper({
    id: Repositories[MFRepositories.Shipment].meta.fml.npmName,
    renderer: getRenderer(MFRepositories.Shipment, 'createShipment', {
      integrator: 'SennTMS',
    }),
    router,
    hooks: {
      failure: logger.error,
    },
  })

  loaded.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_dsf_navbar_item = _resolveComponent("dsf-navbar-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dsf_navbar_item, _mergeProps(_ctx.$attrs, {
      dsf_icon: "CirclePlus",
      dsf_title: _ctx.$t('navigation.item.add-new-cargo'),
      dsf_id: "create_shipment",
      onNavigate: _withModifiers(onAddShipmentClick, ["stop"]),
      disabled: !loaded.value
    }), null, 16 /* FULL_PROPS */, ["dsf_title", "disabled"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(mfWrapper.value)))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})